import { EffectCoverflow, Navigation, Pagination, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/navigation";
import IFHeading from "./IF_Heading";

function Foto({ data }) {
    return (
        <div className="w-full h-full rounded-2xl overflow-hidden relative bg-[#12141e] border border-white/10 group">
            <img
                src={process.env.REACT_APP_IMAGE_ALBUM_URL + data.filename}
                alt={data.name || "Dokumentasi I-FIT Indonesia"}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
            {/* Vignette */}
            <div className="absolute inset-0 pointer-events-none bg-gradient-to-t from-[#08090d]/60 via-transparent to-transparent" />
        </div>
    );
}

function Film({ data }) {
    return (
        <div className="w-full h-full rounded-2xl overflow-hidden bg-black border border-pink/30 flex items-center justify-center">
            <video
                preload="metadata"
                controls
                className="w-full h-full object-cover rounded-2xl"
            >
                <source
                    src={`${process.env.REACT_APP_IMAGE_ALBUM_URL + data.filename}#t=1`}
                    type="video/mp4"
                />
                Your browser does not support the video tag.
            </video>
        </div>
    );
}

export default function IF_Swiper({ data = [] }) {
    if (!data || data.length === 0) return null;

    return (
        <section className="w-full relative py-12 md:py-20 overflow-hidden bg-[#08090d]">
            <IFHeading>GALLERY ALBUM</IFHeading>

            <div className="w-full flex justify-center px-4 mt-4">
                <div className="w-full md:w-[90%] lg:w-[80%] xl:w-[70%] max-w-[1200px]">
                    <Swiper
                        effect={"coverflow"}
                        grabCursor={true}
                        centeredSlides={true}
                        slidesPerView={"auto"}
                        initialSlide={Math.floor(data.length / 2)}
                        coverflowEffect={{
                            rotate: 25,
                            stretch: 0,
                            depth: 140,
                            modifier: 1,
                            slideShadows: false,
                        }}
                        autoplay={{
                            delay: 4500,
                            disableOnInteraction: false,
                            pauseOnMouseEnter: true,
                        }}
                        navigation={true}
                        pagination={{ clickable: true }}
                        modules={[EffectCoverflow, Pagination, Navigation, Autoplay]}
                        style={{
                            paddingTop: "20px",
                            paddingBottom: "60px",
                        }}
                    >
                        {data.map((d, i) => (
                            <SwiperSlide
                                key={i}
                                style={{
                                    width: "320px",
                                    height: "360px",
                                    maxWidth: "80vw",
                                }}
                            >
                                <div className="h-full w-full flex items-center justify-center">
                                    {d.type === "image" ? (
                                        <Foto data={d} />
                                    ) : (
                                        <Film data={d} />
                                    )}
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </section>
    );
}
